export const GBP_RATE = 0.74;
const CAD_RATE = 1.35;
export const EUR_RATE = 0.86;

const EUR = { code: "EUR", symbol: "€", rate: EUR_RATE };

const CURRENCY_BY_MARKETPLACE = {
  uk: { code: "GBP", symbol: "£", rate: GBP_RATE },
  ca: { code: "CAD", symbol: "C$", rate: CAD_RATE },
  de: EUR,
  fr: EUR,
  it: EUR,
  es: EUR,
  nl: EUR,
  be: EUR,
  ie: EUR,
};

// Local currency of a marketplace that can be shown instead of USD, or null
// when the marketplace has no currency toggle.
export const getForeignCurrency = (marketplace) =>
  CURRENCY_BY_MARKETPLACE[marketplace] ?? null;

export const convertCurrency = (value, showForeignCurrency, marketplace) => {
  if (!value) return 0;
  const target = CURRENCY_BY_MARKETPLACE[marketplace];
  if (!showForeignCurrency || !target) return value;
  return (value * target.rate).toFixed(2);
};

// Inverse of convertCurrency: an amount typed in the shown currency, in USD.
export const convertToUsd = (value, showForeignCurrency, marketplace) => {
  const amount = Number(value);
  const target = CURRENCY_BY_MARKETPLACE[marketplace];
  if (!showForeignCurrency || !target) return amount;
  return amount / target.rate;
};

// Ads data is stored in the marketplace's own currency and never converted.
export const getMarketplaceCurrencySymbol = (marketplace) =>
  CURRENCY_BY_MARKETPLACE[marketplace]?.symbol ?? "$";

export const getCurrencySymbol = (showForeignCurrency, marketplace) => {
  const target = CURRENCY_BY_MARKETPLACE[marketplace];
  return showForeignCurrency && target ? target.symbol : "$";
};
